// Tracks which overlay (Modal / Drawer) is on top, so keyboard handling —
// Escape to close, Tab focus trapping — only applies to the top-most one.
// Without this, a Modal opened inside a Drawer (custom device form on mobile)
// closed both on a single Escape press, since both listen on `document`.

const stack = [];

export function pushDialog() {
  const token = {};
  stack.push(token);
  return token;
}

export function removeDialog(token) {
  const index = stack.indexOf(token);
  if (index !== -1) stack.splice(index, 1);
}

export function isTopDialog(token) {
  return stack[stack.length - 1] === token;
}

export const FOCUSABLE_SELECTOR =
  'button, [href], input, select, textarea, [tabindex]:not([tabindex="-1"])';

export function trapTabKey(event, container) {
  if (!container) return;
  const focusables = Array.from(container.querySelectorAll(FOCUSABLE_SELECTOR)).filter(
    (el) => !el.disabled
  );
  if (focusables.length === 0) return;

  const first = focusables[0];
  const last = focusables[focusables.length - 1];

  if (event.shiftKey && document.activeElement === first) {
    event.preventDefault();
    last.focus();
  } else if (!event.shiftKey && document.activeElement === last) {
    event.preventDefault();
    first.focus();
  }
}
